import script from "./SponsorUs.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsorUs.vue?vue&type=script&setup=true&lang=ts"

import "./SponsorUs.vue?vue&type=style&index=0&id=60663a11&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60663a11"]])

export default __exports__